// extracted by mini-css-extract-plugin
export default {"getListTabs":"GetList_getListTabs__vYOK-","getListContainer":"GetList_getListContainer__elYuw"};